import React, { useState } from 'react';
import { 
  FileDigit, 
  Plus, 
  Search, 
  Download, 
  Printer, 
  Trash2, 
  User, 
  Pill,
  History,
  X,
  RefreshCw
} from 'lucide-react';
import { supabase } from '../supabaseClient';
import { useNotifications } from '../context/NotificationContext';
import './Prescriptions.css';

const Prescriptions = () => {
  const { addNotification } = useNotifications();
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('NUEVA');
  
  // New State for Drug Search
  const [drugQuery, setDrugQuery] = useState('');
  const [drugResults, setDrugResults] = useState([]);
  const [selectedDrugs, setSelectedDrugs] = useState([]);
  const [isSearchingDrugs, setIsSearchingDrugs] = useState(false);

  const mockPrescriptions = [
    { id: 1, date: '12/05/2026', patient: 'NELSON FERNANDEZ', items: 'Amoxicilina 500mg, Paracetamol 1g', status: 'Emitida' },
    { id: 2, date: '10/05/2026', patient: 'DARIO SOTELO', items: 'Ibuprofeno 600mg', status: 'Emitida' },
    { id: 3, date: '08/05/2026', patient: 'LEONARDO ROSSI', items: 'Loratadina 10mg', status: 'Anulada' },
  ];

  const handleSearchDrugs = async (query) => {
    setDrugQuery(query);
    if (query.length < 2) {
      setDrugResults([]);
      return;
    }
    setIsSearchingDrugs(true);
    try {
      const { data, error } = await supabase
        .from('vademecum')
        .select('*')
        .ilike('name', `%${query}%`)
        .limit(5);
      if (error) throw error;
      setDrugResults(data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setIsSearchingDrugs(false);
    }
  };

  const addDrugToPrescription = (drug) => {
    if (selectedDrugs.find(d => d.id === drug.id)) return;
    setSelectedDrugs([...selectedDrugs, drug]);
    setDrugQuery('');
    setDrugResults([]);
    addNotification(`${drug.name} agregado a la receta`, 'success');
  };

  const removeDrug = (id) => {
    setSelectedDrugs(selectedDrugs.filter(d => d.id !== id));
  };

  const handleCreatePrescription = () => {
    if (selectedDrugs.length === 0) {
      addNotification('Debe agregar al menos un medicamento', 'error');
      return;
    }
    addNotification('Generando receta electrónica...', 'info');
    setTimeout(() => {
      addNotification('Receta generada con éxito. Abriendo ventana de impresión...', 'success');
      setTimeout(() => {
        window.print();
        setSelectedDrugs([]);
      }, 500);
    }, 1500);
  };

  return (
    <div className="prescriptions-page">
      <div className="prescriptions-header">
        <div className="title-section">
          <FileDigit size={32} className="text-blue" />
          <div>
            <h1>Receta Electrónica</h1>
            <p>Genera prescripciones digitales válidas para farmacias en Argentina</p>
          </div>
        </div>
        <div className="header-actions">
          <button className="btn-primary" onClick={() => setActiveTab('NUEVA')}>
            <Plus size={20} /> NUEVA RECETA
          </button>
        </div>
      </div>

      <div className="prescriptions-tabs-v2">
        <button 
          className={`tab-btn-v2 ${activeTab === 'NUEVA' ? 'active' : ''}`}
          onClick={() => setActiveTab('NUEVA')}
        >
          <Plus size={18} /> Crear Receta
        </button>
        <button 
          className={`tab-btn-v2 ${activeTab === 'HISTORIAL' ? 'active' : ''}`}
          onClick={() => setActiveTab('HISTORIAL')}
        >
          <History size={18} /> Historial
        </button>
      </div>

      <div className="prescriptions-content card">
        {activeTab === 'NUEVA' ? (
          <>
            <div className="new-prescription-form">
              <div className="prescription-form-section">
                <h3 className="section-title"><User size={18} /> Datos del Paciente</h3>
                <div className="search-box-v2">
                  <Search size={20} className="search-icon-v2" />
                  <input type="text" placeholder="Buscar paciente por nombre o DNI..." />
                </div>
              </div>

              <div className="prescription-form-section">
                <h3 className="section-title"><Pill size={18} /> Medicamentos / Indicaciones</h3>
                <div className="drug-search-container-v2">
                  <div className="search-box-v2">
                    <Search size={20} className="search-icon-v2" />
                    <input 
                      type="text" 
                      placeholder="Buscar en Vademecum (Ej: Amoxidal, Ibupirac...)" 
                      value={drugQuery}
                      onChange={(e) => handleSearchDrugs(e.target.value)}
                    />
                    {isSearchingDrugs && <RefreshCw size={18} className="animate-spin text-cyan" />}
                  </div>

                  {drugResults.length > 0 && (
                    <div className="drug-results-dropdown card shadow-lg">
                      {drugResults.map(drug => (
                        <div key={drug.id} className="drug-result-item" onClick={() => addDrugToPrescription(drug)}>
                          <div className="drug-info">
                            <span className="drug-name">{drug.name}</span>
                            <span className="drug-monodroga">{drug.active_ingredient}</span>
                          </div>
                          <Plus size={16} className="text-blue" />
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="selected-drugs-container">
                  {selectedDrugs.length > 0 ? (
                    selectedDrugs.map(drug => (
                      <div key={drug.id} className="selected-drug-card-v2">
                        <div className="selected-drug-info">
                          <span className="selected-drug-name">{drug.name}</span>
                          <span className="selected-drug-meta">{drug.active_ingredient} - 1 unidad cada 8hs</span>
                        </div>
                        <button className="btn-remove-drug" onClick={() => removeDrug(drug.id)}>
                          <X size={16} />
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="empty-medications">
                      <p>Aún no has agregado medicamentos.</p>
                      <p className="subtext">Usa el buscador de Vademecum arriba.</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="form-footer">
                <div className="signature-preview">
                  <div className="signature-box">Firma Digital Registrada</div>
                  <p>Dr. Administrador - MP 12345</p>
                </div>
                <div className="action-btns">
                  <button className="btn-outline">Guardar Borrador</button>
                  <button className="btn-primary" onClick={handleCreatePrescription}>Firmar y Emitir</button>
                </div>
              </div>
            </div>

            {/* Hidden Printable Template */}
            <div id="printable-prescription" className="print-only">
              <div className="print-header">
                <div className="print-logo">GDT</div>
                <div className="print-doctor-info">
                  <h2>Dr. Administrador</h2>
                  <p>Especialista en Otorrinolaringología</p>
                  <p>M.P. 12345 / M.N. 67890</p>
                </div>
              </div>
              
              <div className="print-patient-data">
                <p><strong>Paciente:</strong> _________________________________</p>
                <p><strong>DNI/OS:</strong> ____________________________________ <strong>Fecha:</strong> {new Date().toLocaleDateString()}</p>
              </div>

              <div className="print-body">
                <div className="rx-symbol">Rx</div>
                <div className="print-items">
                  {selectedDrugs.map((drug, i) => (
                    <div key={i} className="print-item">
                      <p className="print-item-name">{drug.name} ({drug.active_ingredient})</p>
                      <p className="print-item-ind">Ind: 1 unidad cada 8 horas. Duración: 7 días.</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="print-footer">
                <div className="print-signature">
                  <div className="sig-line"></div>
                  <p>Firma y Sello</p>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="prescriptions-history">
            <div className="history-filters">
              <div className="search-box">
                <Search size={18} />
                <input 
                  type="text" 
                  placeholder="Filtrar por paciente..." 
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <table className="history-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Paciente</th>
                  <th>Medicamentos</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {mockPrescriptions.map(p => (
                  <tr key={p.id}>
                    <td>{p.date}</td>
                    <td className="font-bold">{p.patient}</td>
                    <td className="text-sm">{p.items}</td>
                    <td>
                      <span className={`status-badge ${p.status.toLowerCase()}`}>
                        {p.status}
                      </span>
                    </td>
                    <td>
                      <div className="history-actions">
                        <button title="Imprimir"><Printer size={16} /></button>
                        <button title="Descargar PDF"><Download size={16} /></button>
                        <button title="Anular" className="text-red"><Trash2 size={16} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Prescriptions;
